import jsPDF from "jspdf";
import { Style, Section } from "../../pages/RegistroVentas/ClasesImpresion";
import printBlob from "../../helpers/printBlob";
import moment from "moment";

export async function printTicketPedidoProduccion(detalles, pedido, extImg = 'png') {
    const DetalleFormateado = detalles.map((item, index) => {
        return {
            ...item,
            Correlativo: index + 1,
            NombreProducto: item.NombreProducto,
            Cantidad: parseFloat(item.Cantidad).toFixed(2),
            Unidad: item.Descripcion,
            Categoria: item.Categoria,
        };
    });

    // Calcular altura dinámica basada en el contenido
    const baseHeight = 120; // Altura base reducida
    const itemsHeight = detalles.length * 6; // 6mm por item
    const totalHeight = Math.min(baseHeight + itemsHeight, 300); // Máximo 300mm
    
    const mmPageSize = [80, totalHeight];
    const ptPageSize = mmPageSize.map(coord => coord * 2.83465);

    var doc = new jsPDF({
        orientation: "portrait",
        unit: "mm",
        format: ptPageSize
    });

    const pageWidth = doc.internal.pageSize.width || doc.internal.pageSize.getWidth();

    // **INICIO CORREGIDO - POSICIONES MÁS COMPACTAS**

    // Título principal - EMPEZAR MÁS ARRIBA
    const EmpresaTittleStyle = new Style(9, "normal", 1, "center");
    const EmpresaTittleSection = new Section(doc, 10, 5, EmpresaTittleStyle, 60); // y:5 en lugar de 21

    EmpresaTittleSection.write("PEDIDO DE PRODUCCIÓN", EmpresaTittleStyle);

    // Línea decorativa después del título
    doc.setDrawColor(0, 0, 0);
    doc.line(4, EmpresaTittleSection.y - 1, 76, EmpresaTittleSection.y - 1);

    // Datos de la empresa/sucursal
    const EmpresaDataStyle = new Style(7, "normal", 1, "center");
    const EmpresaDataSection = new Section(
        doc,
        EmpresaTittleSection.x,
        EmpresaTittleSection.y + 4, // +4 en lugar de -2 (evitar coordenadas negativas)
        EmpresaDataStyle,
        EmpresaTittleSection.width
    );
    
    EmpresaDataSection.write(pedido.NombreSucursal?.toUpperCase() || "SUCURSAL");
    EmpresaDataSection.write(`Usuario: ${pedido.NombreUsuario}`);

    // Línea después de datos empresa
    doc.line(4, EmpresaDataSection.y + 2, 76, EmpresaDataSection.y + 2);

    // Información del pedido
    const PedidoStyle = new Style(10, "bold", 1, "center");
    const PedidoSection = new Section(doc, 10, EmpresaDataSection.y + 4, PedidoStyle, 60); // +4 en lugar de -1
    const PedidoSection2 = new Section(doc, 10, PedidoSection.y + 3, PedidoStyle, PedidoSection.width); // +3 en lugar de +3.5

    PedidoSection.write("PEDIDO N°");
    PedidoSection2.write(pedido.IdPedidoProduccion.toString());
    
    // Línea después del número de pedido
    doc.setDrawColor(0, 0, 0);
    doc.line(4, PedidoSection2.y + 1, 76, PedidoSection2.y + 1);

    // Datos del pedido
    const datosStyle = new Style(8, "normal", 1); 
    const datosSection = new Section(doc, 4, PedidoSection2.y + 3, datosStyle, pageWidth - 6); // +3 en lugar de -2

    datosSection.write(`FECHA EMISIÓN: ${moment(pedido.FechaEmision).format("DD-MM-YYYY")}`);
    datosSection.write(`FECHA ENTREGA: ${moment(pedido.FechaEntrega).format("DD-MM-YYYY")}`);
    datosSection.write(`ESTADO: ${pedido.Estado}`);
    datosSection.write(`SUCURSAL: ${pedido.NombreSucursal}`);

    // Líneas antes y después de datos
    doc.setDrawColor(0, 0, 0);
    doc.line(4, datosSection.y - 1, 76, datosSection.y - 1);
    doc.line(4, datosSection.y + 4, 76, datosSection.y + 4); // +4 en lugar de +4.5

    // Tabla de detalles - POSICIÓN CORREGIDA
    const tableStartY = datosSection.y + 5; // +5 en lugar de -2
    
    doc.autoTable({
        body: DetalleFormateado,
        bodyStyles: {
            fontSize: 8,
            fontStyle: "normal",
            cellPadding: 1,
            lineHeight: 1 // Reducir lineHeight
        },
        headStyles: {
            fontSize: 7,
            lineHeight: 1 // Reducir lineHeight
        },
        startY: tableStartY,
        showHead: "firstPage",
        margin: {
            right: 3,
            left: 3,
        },
        rowPageBreak: "avoid",
        columnStyles: {
            NombreProducto: {columnWidth: 25, fontSize: 7},
            Cantidad: {columnWidth: 10, fontSize: 7, halign: "right"},
            Unidad: {columnWidth: 10, fontSize: 7, halign: "center"},
            Categoria: {columnWidth: 15, fontSize: 7, halign: "center"},
        },
        styles: {
            overflow: "linebreak",
            tableWidth: "auto",
            columnWidth: "auto",
            halign: "left",
            fontSize: 7,
            lineHeight: 1 // Reducir lineHeight
        },
        columns: [
            {header: "PROD", dataKey: "NombreProducto"},
            {header: "CANT", dataKey: "Cantidad"},
            {header: "UNIDAD", dataKey: "Unidad"},
            {header: "CATEG", dataKey: "Categoria"},
        ],
        theme: "plain"
    });
        
    let finalTable = doc.autoTable.previous.finalY + 1; // +1 en lugar de -1
    doc.setDrawColor(0, 0, 0);
    doc.line(4, finalTable, 76, finalTable);

    // Total general
    const totalCantidad = detalles.reduce((sum, item) => sum + parseFloat(item.Cantidad || 0), 0);
    
    const totalStyle = new Style(9, "bold", 1.15, "right");
    const totalSection = new Section(doc, 40, finalTable + 2, totalStyle, 35); // +2 en lugar de +2 (correcto)
    
    totalSection.write(`TOTAL GENERAL: ${totalCantidad.toFixed(2)}`);

    doc.setDrawColor(0, 0, 0);
    doc.line(4, totalSection.y + 1, 76, totalSection.y + 1); // +1 en lugar de -1

    // Observaciones
    const ObservacionStyle = new Style(7, "normal", 1);
    const ObservacionSection = new Section(doc, 4, totalSection.y + 2, ObservacionStyle, 72); // +2 en lugar de +1

    ObservacionSection.write(`OBSERVACIÓN: ${pedido.Observacion || "Sin observaciones"}`);

    // Firmas para pedidos de producción - REDUCIDAS
    const heightForSignatureSquare = 18; // 18mm en lugar de 25mm

    const SolicitadoPorStyle = new Style(7, "normal", 1);
    const SolicitadoPorSection = new Section(doc, 4, ObservacionSection.y + 3, SolicitadoPorStyle, 72); // +3 en lugar de +3
    SolicitadoPorSection.write(`EMITIDO: `);
    doc.rect(4, SolicitadoPorSection.y + 1, pageWidth - 8, heightForSignatureSquare);
    

    const EntregadoProduccionStyle = new Style(7, "normal", 1);
    const EntregadoProduccionSection = new Section(
        doc,
        4,
        SolicitadoPorSection.y + heightForSignatureSquare + 2, // +2 en lugar de +2
        EntregadoProduccionStyle,
        72
    );
    EntregadoProduccionSection.write(`ENTREGADO: `);
    doc.rect(4, EntregadoProduccionSection.y + 1, pageWidth - 8, heightForSignatureSquare);

    doc.autoPrint();
    printBlob(doc.output("bloburl"));
}

export async function handlePrintTicketPedido(pedido, detalles, extImg = 'png') {
    try {
        await printTicketPedidoProduccion(detalles, pedido, extImg);
    } catch (error) {
        console.error("Error al imprimir ticket:", error);
        throw error;
    }
}